import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box } from "@mui/material";
import { ISortableAreaCard } from "./interfaces";

export function SortableAreaCard({ id, children, isExpanded }: ISortableAreaCard) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        cursor: isExpanded ? "default" : "grab",
    };

    const dragProps = isExpanded ? {} : { ...attributes, ...listeners };

    return (
        <Box ref={setNodeRef} style={style} {...dragProps}>
            {children}
        </Box>
    );
}
